import { useState } from 'react';

const MaterialiCard = ({ nome, descrizione, immagine, applicazioni }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="relative h-96 rounded-lg overflow-hidden group cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Immagine */}
      <img 
        src={immagine} 
        alt={nome} 
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
      />
      
      {/* Overlay con gradiente */}
      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70"></div>
      
      {/* Contenuto */}
      <div className="absolute bottom-0 left-0 right-0 p-6 transform transition-transform duration-500 ease-in-out" style={{
        transform: isHovered ? 'translateY(0)' : 'translateY(76px)'
      }}>
        <h3 className="text-2xl font-bold text-white mb-3">{nome}</h3>
        <p className="text-gray-200 mb-4">{descrizione}</p>
        
        <div className="opacity-0 transition-opacity duration-300" style={{ opacity: isHovered ? 1 : 0 }}>
          <h4 className="text-lg font-semibold text-white mb-2">Applicazioni principali:</h4>
          <ul className="text-gray-300 space-y-1 list-disc list-inside">
            {applicazioni.map((app, index) => (
              <li key={index}>{app}</li>
            ))}
          </ul>
        </div>
      </div>
      
      {/* Etichetta decorativa */}
      <div className="absolute top-4 right-4 bg-white/10 backdrop-blur-sm px-3 py-1 rounded text-sm text-white">
        Disponibile
      </div>
    </div>
  );
};

const Materiali = () => {
  const materialiList = [
    {
      nome: "Acciaio",
      descrizione: "Disponibile in diverse tipologie e formati, ideale per applicazioni strutturali e industriali.",
      immagine: "/images/materiali_1.webp",
      applicazioni: [
        "Costruzioni e infrastrutture",
        "Macchinari industriali",
        "Automotive",
        "Prodotti di consumo"
      ]
    },
    {
      nome: "Rame",
      descrizione: "Materiale ad alta conducibilità, perfetto per applicazioni elettriche e termoidrauliche.",
      immagine: "/images/materiali_2.webp",
      applicazioni: [
        "Cablaggi elettrici",
        "Componenti elettronici",
        "Scambiatori di calore",
        "Tubazioni per impianti"
      ]
    },
    {
      nome: "Alluminio",
      descrizione: "Leggero e resistente alla corrosione, ideale per soluzioni che richiedono peso ridotto.",
      immagine: "/images/materiali_3.webp",
      applicazioni: [
        "Aerospace",
        "Automotive",
        "Packaging",
        "Costruzioni leggere"
      ]
    },
    {
      nome: "Ottone",
      descrizione: "Lega di rame e zinco con eccellente lavorabilità e resistenza alla corrosione.",
      immagine: "/images/materiali_4.webp",
      applicazioni: [
        "Valvole e raccordi",
        "Componenti decorativi",
        "Strumenti musicali",
        "Applicazioni marine"
      ]
    },
    {
      nome: "Acciaio Inox",
      descrizione: "Resistente alla corrosione e alle alte temperature, ideale per applicazioni severe.",
      immagine: "/images/materiali_5.webp",
      applicazioni: [
        "Industria alimentare",
        "Settore chimico",
        "Applicazioni marine",
        "Elettrodomestici"
      ]
    }
  ];

  return (
    <section id="materiali" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4">
            <span className="w-12 h-[1px] bg-gray-400"></span>
            <span className="mx-4 text-gray-500 uppercase text-sm tracking-widest font-light">La nostra offerta</span>
            <span className="w-12 h-[1px] bg-gray-400"></span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">I Nostri Materiali</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Offriamo una vasta selezione di materiali metallici e industriali di alta qualità, 
            con disponibilità costante e possibilità di forniture personalizzate.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
  {materialiList.slice(0, 3).map((materiale, index) => (
    <div key={index} className="relative h-64 rounded-lg overflow-hidden group">
      <img
        src={materiale.immagine}
        alt={materiale.nome}
        className="object-cover w-full h-full filter blur-sm scale-105 transition duration-300 ease-in-out group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition duration-300" />
      <div className="absolute inset-0 flex items-center justify-center p-4 text-white text-center z-10">
        <div>
          <h2 className="text-xl font-bold">{materiale.nome}</h2>
          <p className="text-sm mt-2">{materiale.descrizione}</p>
        </div>
      </div>
    </div>
  ))}
</div>

{/* Seconda riga: ultimi 2 elementi centrati */}
<div className="flex justify-center gap-6 flex-wrap">
  {materialiList.slice(3).map((materiale, index) => (
    <div className="w-full md:w-1/2 lg:w-1/3" key={index}>
      <div className="relative h-64 rounded-lg overflow-hidden group">
        <img
          src={materiale.immagine}
          alt={materiale.nome}
          className="object-cover w-full h-full filter blur-sm scale-105 transition duration-300 ease-in-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition duration-300" />
        <div className="absolute inset-0 flex items-center justify-center p-4 text-white text-center z-10">
          <div>
            <h2 className="text-xl font-bold">{materiale.nome}</h2>
            <p className="text-sm mt-2">{materiale.descrizione}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

<div className="mt-16 text-center">
  <a href="#contatti" className="inline-block px-8 py-4 bg-gray-900 text-white font-medium rounded shadow-lg hover:bg-gray-800 transition-all duration-300">
    Richiedi catalogo completo
  </a>
</div>

      </div>
    </section>
  );
};

export default Materiali;